import Alert from "@/common/components/Alert";
import { InfoIcon } from "lucide-react";

const CompanyCreditAlert = () => {
  return (
    <Alert
      variant="warning"
      Icon={InfoIcon}
      containerClassName="bg-transparent p-0"
    >
      <div className="flex flex-col">
        <p className="text-xs">
          Essa empresa não possui crédito, toda sua operação será baseada em Saldo.
        </p>

        <p className="text-xs italic font-light">
          A empresa obrigatoriamente precisará abastecer sua carteira via Pix para transacionar.
        </p>
      </div>
    </Alert>
  );
}

export default CompanyCreditAlert;
